import { render } from "./Checkbox.vue?vue&type=template&id=030b68ff&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=030b68ff&lang=scss&scoped=true"
import "./Checkbox.vue?vue&type=style&index=1&id=030b68ff&lang=css"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030b68ff"]])

export default __exports__